/* eslint-disable @typescript-eslint/no-explicit-any */
import { AVAILABLE_LANGUAGES } from '#shared/lang.model.js';
import { projectKindSchema } from '#shared/projectKind.model.js';
import { projectOutputEntitySchema } from '#shared/projectOutput.model.js';
import { comparisonEntitySchema } from '#shared/projects.comparison.model.js';
import { contributorEntitySchema } from '#shared/projects.contributor.model.js';
import { comparisonFiltersEntitySchema, filtersEntitySchema } from '#shared/projects.filters.model.js';
import { goalEntitySchema, goalEntityToSaveSchema } from '#shared/projects.goal.model.js';
import { productEntitySchema } from '#shared/projects.product.model.js';
import { userEntitySchema, userEntityToCreateSchema } from '#shared/projects.user.model.js';
import { z } from 'zod';
const projectEntitySchema = z.object({
    id: z.number(),
    name: z.string(),
    description: z.string().max(400),
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    supplierName: z.string().optional(),
    kind: projectKindSchema,
    owner: userEntitySchema,
    createdAt: z.coerce.date(),
    contributors: z.array(contributorEntitySchema),
    perimeterFilters: filtersEntitySchema,
    comparisons: z.array(comparisonEntitySchema),
    goals: z.array(goalEntitySchema),
    output: projectOutputEntitySchema.optional(),
    product: productEntitySchema
});
const projectEntityToSaveSchema = z.object({
    id: z.number().optional(),
    name: z.string().min(1),
    description: z.string().max(400),
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    kindId: z.number(),
    supplierName: z.string().optional(),
    owner: userEntityToCreateSchema,
    perimeterFilters: filtersEntitySchema,
    comparisons: z.array(comparisonFiltersEntitySchema),
    goals: z.array(goalEntityToSaveSchema),
    productId: z.number()
});
const projectEntityToShareSchema = z.object({
    projectId: z.number(),
    ownerEmail: z.email(),
    viewersEmails: z.string().array().min(1),
    preferredLanguage: z.enum(AVAILABLE_LANGUAGES)
});
const usageTrackingToExportSchema = z.object({
    type: z.enum(['projects', 'contributors', 'goals'])
});
const projectContributorToDeleteSchema = z.object({
    projectId: z.number(),
    ownerEmail: z.email(),
    contributorEmail: z.email()
});
export { projectContributorToDeleteSchema, projectEntitySchema, projectEntityToSaveSchema, projectEntityToShareSchema, usageTrackingToExportSchema };
//# sourceMappingURL=project.model.js.map